module.exports = __webpack_public_path__ + "static/media/near-space.f4ea8aca.jpg";